import { render, staticRenderFns } from "./Addproducts_component.vue?vue&type=template&id=f5fe3cc2&scoped=true&"
import script from "../../assets/customer/js/addproducts.js?vue&type=script&lang=js&"
export * from "../../assets/customer/js/addproducts.js?vue&type=script&lang=js&"
import style0 from "./Addproducts_component.vue?vue&type=style&index=0&id=f5fe3cc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5fe3cc2",
  null
  
)

export default component.exports